export const Border = {
  Radius: "15px",
  RadiusXs: "4px",
};
